// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "Footer-module--bx--text-truncate--end--Kn3d8";
export var bxTextTruncateFront = "Footer-module--bx--text-truncate--front--P2amA";
export var content = "Footer-module--content--4fCzr";
export var footer = "Footer-module--footer--spNBO";
export var grid = "Footer-module--grid--8NRdN";
export var listItem = "Footer-module--listItem--Aj70k";
export var logo = "Footer-module--logo--ziLRb";
export var nav = "Footer-module--nav--Qgwj6";